import { useState } from "react";
import CustomInput from "../../../components/CustomInput";
import SubHeadings from "../../../components/SubHeadings";
import { Staff } from "../../../types/staff";
import { useFormEdit } from "../../../util/hooks/useFormEdit";
import CustomSelect from "../../../components/CustomSelect";

interface staffExitProps {
  staff?: Staff;
  onChange: (data: Partial<Staff>) => void;
}

export default function StaffExitDetails({ staff, onChange }: staffExitProps) {
  const { isEditing } = useFormEdit<Staff>(staff || ({} as Staff));

  const handleInputChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = event.target;
    onChange({ [name]: value });
  };

  return (
    <div className="px-4 md:px-9 flex flex-col-reverse md:flex-row divide-x divide-neutral-50 gap-9">
      <div className="flex flex-col gap-7 w-full py-7">
        <div className="flex justify-between items-center gap-4">
          <SubHeadings text="Staff Exit Details" />
          <aside className="text-xs font-medium text-error-500">
            *To be filled by HR
          </aside>
        </div>
        <form className="">
          <div className="grid md:grid-cols-2 2xl:grid-cols-3 gap-7 items-start">
            <div className="flex flex-col min-h-full">
              <CustomInput
                name="noticePeriod"
                label="Notice period"
                type="text"
                readOnly={!isEditing}
                placeholder="------"
                value={staff.noticePeriod}
                onChange={handleInputChange}
                inputClassName=""
              />
            </div>
            <div className="flex flex-col min-h-full">
              <CustomInput
                name="noticePeriodStatus"
                label="Notice period status"
                type="text"
                placeholder="------"
                readOnly={!isEditing}
                value={staff.noticePeriodStatus}
                onChange={handleInputChange}
                inputClassName=""
              />
            </div>
            <div className="flex flex-col min-h-full">
              <CustomInput
                name="reasonForLeaving"
                label="Reason for leaving"
                type="text"
                readOnly={!isEditing}
                placeholder="------"
                value={staff.reasonForLeaving}
                onChange={handleInputChange}
                inputClassName="w-full"
              />
            </div>
            <div className="flex flex-col min-h-full">
              <CustomSelect
                name="duesCollected"
                label="All school related dues/resources collected?"
                readOnly={!isEditing}
                value={
                  staff.duesCollected === true
                    ? "true"
                    : staff.duesCollected === false
                      ? "false"
                      : ""
                }
                options={[
                  { label: "Yes", value: "true" },
                  { label: "No", value: "false" },
                ]}
                placeholder="------"
                onChange={(e) => {
                  const value = e.target.value;
                  onChange({
                    duesCollected:
                      value === "true"
                        ? true
                        : value === "false"
                          ? false
                          : null,
                  });
                }}
              />
            </div>
            <div className="flex flex-col min-h-full">
              <CustomInput
                name="bankName"
                label="Bank name"
                type="text"
                placeholder="------"
                readOnly={!isEditing}
                value={staff.bankName}
                onChange={handleInputChange}
                inputClassName="w-full"
              />
            </div>
            <div className="flex flex-col min-h-full">
              <CustomInput
                name="ifscCode"
                label="IFSC code"
                type="text"
                readOnly={!isEditing}
                placeholder="------"
                value={staff.ifscCode}
                onChange={handleInputChange}
                inputClassName="w-full"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
